import {RestApiError} from "../../data/models/RestApi";
import * as React from "react";
import {DefaultErrorBoundaryFallback} from "../../../../../ErrorBoundary/DefaultErrorBoundaryFallback";
import {AppTranslations} from "../../../../../components/Utils/translations/AppTranslations";

export const getErrorMessage = (
    error: Error | RestApiError,
    AppTranslations: AppTranslations,
): React.ReactNode => {
    const isRestApiError = (error as RestApiError)?.errorType;
    if (isRestApiError) {
        return (
            <DefaultErrorBoundaryFallback
                errorTitle={AppTranslations.errorMessages.unexpectedError}
                errorMessage={(error as RestApiError)?.message}
                style={{backgroundColor: "white"}}
            />
        );
    } else if ((error as Error)?.message) {
        return (
            <DefaultErrorBoundaryFallback
                errorTitle={AppTranslations.errorMessages.unexpectedError}
                errorMessage={(error as Error)?.message}
                style={{backgroundColor: "white"}}
            />
        );
    } else {
        return <DefaultErrorBoundaryFallback
            style={{backgroundColor: "white"}}
        />;
    }
};
